import { getLocation } from '@jira/ssr__browser-globals/src/getLocation.tsx';
import { jiraSuperBatchDependencies } from './constants.tsx';

let isSuperBatchDependenciesLoaded = false;

const isOnRapidBoardsPage = () => {
	const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
	const backlogsRegex =
		/\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;

	const location = getLocation();
	if (!location) {
		return false;
	}
	const { pathname } = location;
	return (
		boardsRegex.test(pathname) ||
		backlogsRegex.test(pathname) ||
		location.href.includes('secure/RapidBoard.jspa')
	);
};

export const prependSuperBatchDepsOnce = (wrmKeys: string | string[]): string | string[] => {
	// These usually need injecting before most domain-specific deps but in rapidboards they load a
	// smaller set of the needed deps internally early and delay the rest
	if (isSuperBatchDependenciesLoaded || isOnRapidBoardsPage()) {
		return wrmKeys;
	}

	isSuperBatchDependenciesLoaded = true;
	return jiraSuperBatchDependencies.concat(wrmKeys);
};
